var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-collapse",
        {
          attrs: { accordion: "" },
          model: {
            value: _vm.activeFilter,
            callback: function($$v) {
              _vm.activeFilter = $$v
            },
            expression: "activeFilter"
          }
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { name: "filters" } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticStyle: { width: "50%" } }, [
                  _vm._v("Saisie des commandes")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "50%",
                      display: "inline",
                      "text-align": "right",
                      "margin-right": "15px"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: _vm.filterExists ? "danger" : "success",
                          size: "mini"
                        }
                      },
                      [_vm._v("Filtres")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n        Vous pouvez effectuer une "),
                _c("strong", [_vm._v("recherche par numéro d'affaire")]),
                _vm._v(
                  " si vous le connaissez,\n        sinon vous pouvez utiliser les "
                ),
                _c("strong", [_vm._v("listes de clients et enseignes")]),
                _vm._v(
                  " pour filtrer les affaires\n        selon vos critères de recherche.\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                { attrs: { "label-width": "250px", size: "mini" } },
                [
                  _c(
                    "el-row",
                    { staticStyle: { margin: "10px 0 10px 0" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "white-space": "nowrap" },
                                  attrs: { align: "left", span: 3 }
                                },
                                [
                                  _c("div", [_vm._v("Clients :")]),
                                  _vm._v(" "),
                                  _c("list-client", {
                                    key: "id_client_" + _vm.filters.idClient,
                                    attrs: {
                                      idClient: _vm.filters.idClient,
                                      client: _vm.filters.client
                                    },
                                    on: {
                                      "update:idClient": [
                                        function($event) {
                                          return _vm.$set(
                                            _vm.filters,
                                            "idClient",
                                            $event
                                          )
                                        },
                                        function($event) {
                                          _vm.filters.idEnseigne = null
                                        }
                                      ],
                                      "update:id-client": function($event) {
                                        return _vm.$set(
                                          _vm.filters,
                                          "idClient",
                                          $event
                                        )
                                      },
                                      "update:client": function($event) {
                                        return _vm.$set(
                                          _vm.filters,
                                          "client",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "white-space": "nowrap" },
                                  attrs: { align: "left", span: 3 }
                                },
                                [
                                  _c("div", [_vm._v("Enseignes :")]),
                                  _vm._v(" "),
                                  _c("list-enseigne", {
                                    key:
                                      "id_enseigne_" +
                                      _vm.filters.idClient +
                                      "_" +
                                      _vm.filters.idEnseigne,
                                    attrs: {
                                      idClient: _vm.filters.idClient,
                                      idEnseigne: _vm.filters.idEnseigne,
                                      enseigne: _vm.filters.enseigne,
                                      disabled: !_vm.filters.idClient
                                    },
                                    on: {
                                      "update:idClient": function($event) {
                                        return _vm.$set(
                                          _vm.filters,
                                          "idClient",
                                          $event
                                        )
                                      },
                                      "update:id-client": function($event) {
                                        return _vm.$set(
                                          _vm.filters,
                                          "idClient",
                                          $event
                                        )
                                      },
                                      "update:idEnseigne": function($event) {
                                        return _vm.$set(
                                          _vm.filters,
                                          "idEnseigne",
                                          $event
                                        )
                                      },
                                      "update:id-enseigne": function($event) {
                                        return _vm.$set(
                                          _vm.filters,
                                          "idEnseigne",
                                          $event
                                        )
                                      },
                                      "update:enseigne": function($event) {
                                        return _vm.$set(
                                          _vm.filters,
                                          "enseigne",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "white-space": "nowrap" },
                                  attrs: { align: "right", span: 18 }
                                },
                                [
                                  _c("div", [_vm._v("N° Affaire :")]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticStyle: { width: "150px" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "Rechercher",
                                      size: "mini"
                                    },
                                    model: {
                                      value: _vm.filters.numeroAffaire,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "numeroAffaire",
                                          $$v
                                        )
                                      },
                                      expression: "filters.numeroAffaire"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("affaire-list", {
        key: _vm.refresh,
        attrs: { filters: _vm.filters, manager: "commande" },
        on: { "select-affaire": _vm.handleManageCommande }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }